import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import styled from "styled-components";

import Checkbox from "../../atoms/input/checkbox";
import GrayBtn from "../../atoms/button/grayBtn";
import PretendardText from "../../atoms/text/pretendardText";
import MemberApi from "../../../api/member.api";
import { toast } from "react-toastify";
import { toastMsg } from "../../../util/toastMsg";
import { errorHandler } from "../../../util/errorHandler";
import SelectBoxValue from "../selectBoxValue";
import MainInput from "../../atoms/input/mainInput";
import WritingLinkApi from "../../../api/writingLink.api";

const WLPointChange = ({
  userCheckedIdList,
  getMemberList,
  sessionStorageInit,
  setButtonGroupOpen,
  setButtonGroupFilterOpen,
}) => {
  const navigate = useNavigate();
  const [alarmFlag, setAlarmFlag] = useState(false);

  // 포인트 변경 관련
  const [provideOrDeductBoxOpen, setProvideOrDeductBoxOpen] = useState(false);
  const [selectedProvideOrDeduct, setSelectedProvideOrDeduct] =
    useState("true");

  const [amount, setAmount] = useState("");
  const [reason, setReason] = useState("");
  const pointTypeList = [
    {
      title: "지급",
      value: "true",
    },
    {
      title: "차감",
      value: "false",
    },
  ];

  const [completedCheck, setCompletedCheck] = useState(false);
  const [notPaid, setNotPaid] = useState(false);

  function isNumericString(str) {
    const regex = /^\d+$/;
    return regex.test(str);
  }

  const pointSettingFunc = async () => {
    try {
      if (!isNumericString(String(amount))) {
        return toast("금액은 숫자만 입력 가능합니다.");
      }

      let writingLinkHistoryIds = userCheckedIdList.map((item) => item.id);
      let memberIdsTemp = userCheckedIdList.map((item) => item.senderId);

      const data = {
        writingLinkHistoryIds: writingLinkHistoryIds,
        memberIds: memberIdsTemp,
        amount: Number(amount),
        reason: reason,
        isPlus: selectedProvideOrDeduct === "true" ? true : false,
        alarmFlag: alarmFlag,
      };

      await WritingLinkApi.updatePoint(data);
      await changeActiveFunc();
      getMemberList();
      toast(toastMsg.create);
      setButtonGroupOpen(false);
      sessionStorageInit();
    } catch (error) {
      errorHandler(error);
    }
  };

  const changeActiveFunc = async () => {
    try {
      if (!completedCheck && !notPaid) {
        return;
      }

      const data = {
        activation: completedCheck ? true : false,
      };

      for (let i = 0; i < userCheckedIdList.length; i++) {
        await WritingLinkApi.updateDistribute(userCheckedIdList[i].id, data);
      }
    } catch (error) {
      errorHandler(error);
    }
  };

  return (
    <FilterWrapper
      style={{
        width: 230,
        top: 36,
        padding: 16,
      }}
    >
      <FilterTitle
        style={{
          marginBottom: 10,
        }}
      >
        지급 또는 차감
      </FilterTitle>
      <SelectBoxValue
        isSmall={true}
        selectedValue={selectedProvideOrDeduct}
        isOpen={provideOrDeductBoxOpen}
        wrapperHandler={() => {
          setProvideOrDeductBoxOpen(!provideOrDeductBoxOpen);
        }}
        itemList={pointTypeList}
        selectedValueSetterFunc={(value) => {
          setSelectedProvideOrDeduct(value);
        }}
      />
      <FilterTitle
        style={{
          margin: "12px 0px 10px 0px",
        }}
      >
        지급 금액
      </FilterTitle>
      <MainInput
        type={"text"}
        placeholder={"0"}
        style={{
          width: "198px",
        }}
        value={amount}
        onChange={(e) => {
          setAmount(e.target.value);
        }}
      />
      <FilterTitle
        style={{
          margin: "12px 0px 10px 0px",
        }}
      >
        사유
      </FilterTitle>
      <MainInput
        type={"text"}
        placeholder={"사유를 입력해주세요"}
        style={{
          width: "198px",
        }}
        value={reason}
        onChange={(e) => {
          setReason(e.target.value);
        }}
      />
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          margin: "12px 0px 16px 0px",
          gap: 12,
        }}
      >
        <CheckboxWrapper
          onClick={() => {
            setAlarmFlag(!alarmFlag);
          }}
        >
          <Checkbox
            checked={alarmFlag}
            onChange={() => {
              setAlarmFlag(!alarmFlag);
            }}
          />
          <CheckboxText
            style={{
              fontSize: "15px",
              fontWeight: "500",
              lineHeight: "21.5px",
              color: "#aaa",
            }}
          >
            알림 전송하기
          </CheckboxText>
        </CheckboxWrapper>
        <CheckboxWrapper
          onClick={() => {
            if (notPaid) {
              toast("상태 변경은 하나만 선택 가능합니다.");
              return;
            }

            setCompletedCheck(!completedCheck);
          }}
        >
          <Checkbox checked={completedCheck} />
          <CheckboxText
            style={{
              fontSize: "15px",
              fontWeight: "500",
              lineHeight: "21.5px",
              color: "#aaa",
            }}
          >
            지급 완료로 상태 변경
          </CheckboxText>
        </CheckboxWrapper>
        <CheckboxWrapper
          onClick={() => {
            if (completedCheck) {
              toast("상태 변경은 하나만 선택 가능합니다.");
              return;
            }

            setNotPaid(!notPaid);
          }}
        >
          <Checkbox checked={notPaid} />
          <CheckboxText
            style={{
              fontSize: "15px",
              fontWeight: "500",
              lineHeight: "21.5px",
              color: "#aaa",
            }}
          >
            미지급으로 상태 변경
          </CheckboxText>
        </CheckboxWrapper>
      </div>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "flex-end",
          gap: 8,
        }}
      >
        <GrayBtn
          style={{
            backgroundColor: "#313233",
          }}
          onClick={() => {
            setButtonGroupFilterOpen({
              pointChange: false,
              provideType: false,
              provideStatus: false,
            });
          }}
        >
          취소
        </GrayBtn>
        <GrayBtn
          style={{
            backgroundColor: "#313233",
          }}
          onClick={() => {
            pointSettingFunc();

            setButtonGroupFilterOpen({
              pointChange: false,
              provideType: false,
              provideStatus: false,
            });
          }}
        >
          적용
        </GrayBtn>
      </div>
    </FilterWrapper>
  );
};

export default WLPointChange;

const FilterWrapper = styled.div.attrs((props) => {})`
  padding: 10px;
  border-radius: 3px;
  background: #272829;
  box-shadow: 0px 2px 5px 0px rgba(0, 0, 0, 0.25);
  display: flex;
  flex-direction: column;
  position: absolute;
  top: 48px;
  z-index: 5;
`;

const FilterTitle = styled(PretendardText).attrs((props) => {})`
  font-weight: 500;
  font-size: 13px;
  line-height: 18.75px;
  color: #aaa;
`;

const CheckboxWrapper = styled.div.attrs((props) => {})`
  display: flex;
  align-items: center;
  gap: 8px;
`;

const CheckboxText = styled(PretendardText).attrs((props) => {})`
  font-size: 15px;
  font-weight: 500;
  line-height: 21.5px;
  color: #aaa;

  cursor: pointer;
`;
